import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { useMutation } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import { UPDATE_PROJECT } from "utils/api/graphql/mutations/projects";
import Cart from "./Components/Cart";
import ContactUs from "./Components/ContactUs";
import Header from "./Components/Header";
import Loading from "./Components/Spin";

const Template = ({
  loading,
  contact,
  progress,
  onBack,
  View,
  HeaderComponent,
  project,
  hideHelp,
}) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const TRANSLATION = t("B2C_LMF.TEMPLATE", { returnObjects: true });
  const [help, setHelp] = useState(true);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [updateProject] = useMutation(UPDATE_PROJECT);

  const onSubmit = (data) => {
    const payload = data.payload || data;

    updateProject({
      variables: {
        where: { id: project?.id },
        data: payload,
      },
      onCompleted: data.onCompleted,
    });
  };

  return (
    <>
      <Header
        progressValue={progress}
        View={HeaderComponent && <Cart {...HeaderComponent} />}
        help={help && !hideHelp}
        setHelp={setHelp}
        helpText={TRANSLATION.HELP}
        contact={contact}
        isMobile={isMobile}
        project={project}
        onSubmit={onSubmit}
        hideHelp={hideHelp}
      />
      <div className="lmf__main">
        {loading ? <Loading /> : View}
        {!hideHelp && !isMobile && (
          <ContactUs
            contact={contact}
            display={true}
            text={TRANSLATION.HELP}
            help={help}
            setHelp={setHelp}
            project={project}
            onSubmit={onSubmit}
          />
        )}
      </div>
    </>
  );
};

export default Template;
